import { apiFetch } from './http';

export const CALENDAR_MARKER_KINDS = ['festivo', 'local', 'puente', 'puente_media'];

export async function fetchCalendarMarkers() {
  const data = await apiFetch('/api/calendar-markers');
  return Array.isArray(data?.markers) ? data.markers : [];
}

export async function upsertCalendarMarker(payload) {
  const result = await apiFetch('/api/calendar-markers', {
    method: 'POST',
    body: payload
  });
  return result?.marker || null;
}
